/* Diecast Utopia — Shopify OS 2.0 Theme JS
 * Handles: sticky header, mobile menu, mega menu, announcement rotator,
 * marquee, product carousel scroll, cart drawer (AJAX), search modal (predictive),
 * qty controls, product zoom, add-to-cart, wishlist (localStorage), toast.
 */

(function () {
  'use strict';

  const $  = (sel, root = document) => root.querySelector(sel);
  const $$ = (sel, root = document) => Array.from(root.querySelectorAll(sel));
  const money = (cents) => {
    const f = window.theme.moneyFormat || '${{amount}}';
    const val = (cents / 100).toLocaleString('en-IN', { maximumFractionDigits: 2 });
    return f.replace(/\{\{\s*amount(_no_decimals)?\s*\}\}/g, val);
  };

  const toast = (msg) => {
    const el = $('#toast'); if (!el) return;
    el.textContent = msg; el.hidden = false;
    clearTimeout(el._t);
    el._t = setTimeout(() => (el.hidden = true), 2200);
  };
  window.__toast = toast;

  // ---------- Sticky Header ----------
  const header = $('.site-header');
  if (header) {
    const onScroll = () => header.classList.toggle('scrolled', window.scrollY > 20);
    onScroll();
    window.addEventListener('scroll', onScroll, { passive: true });
  }

  // ---------- Mobile Menu ----------
  const mobileMenu = $('.mobile-menu');
  $$('[data-mobile-open]').forEach((b) => b.addEventListener('click', () => mobileMenu && mobileMenu.classList.add('open')));
  $$('[data-mobile-close]').forEach((b) => b.addEventListener('click', () => mobileMenu && mobileMenu.classList.remove('open')));
  $$('.mobile-menu a').forEach((a) => a.addEventListener('click', () => mobileMenu && mobileMenu.classList.remove('open')));

  // ---------- Announcement rotator ----------
  $$('[data-announcement]').forEach((wrap) => {
    const items = $$('.msg', wrap);
    if (items.length <= 1) return;
    let i = 0;
    items.forEach((el, j) => (el.style.display = j === 0 ? 'inline' : 'none'));
    setInterval(() => {
      items[i].style.display = 'none';
      i = (i + 1) % items.length;
      items[i].style.display = 'inline';
      items[i].classList.remove('animate-fadeUp'); void items[i].offsetWidth;
      items[i].classList.add('animate-fadeUp');
    }, 4000);
  });

  // ---------- Carousel controls ----------
  $$('.carousel-sec').forEach((sec) => {
    const track = $('.carousel-track', sec);
    const prev = $('[data-carousel-prev]', sec);
    const next = $('[data-carousel-next]', sec);
    if (!track) return;
    const scroll = (dir) => track.scrollBy({ left: dir * (track.clientWidth * 0.8), behavior: 'smooth' });
    if (prev) prev.addEventListener('click', () => scroll(-1));
    if (next) next.addEventListener('click', () => scroll(1));
  });

  // ---------- Marquee duplication ----------
  $$('.marquee-row').forEach((row) => {
    if (row.dataset.duped) return;
    row.dataset.duped = '1';
    row.innerHTML = row.innerHTML + row.innerHTML;
    row.classList.add('animate-marquee');
  });

  // ---------- Wishlist (localStorage) ----------
  const wishlistKey = 'du_wishlist';
  const getWishlist = () => { try { return JSON.parse(localStorage.getItem(wishlistKey) || '[]'); } catch { return []; } };
  const setWishlist = (arr) => localStorage.setItem(wishlistKey, JSON.stringify(arr));
  const syncWishlistUI = () => {
    const wl = getWishlist();
    $$('[data-wishlist-btn]').forEach((btn) => {
      const id = btn.dataset.wishlistBtn;
      btn.classList.toggle('wished', wl.includes(id));
    });
    const badge = $('[data-wishlist-count]');
    if (badge) { badge.textContent = wl.length; badge.hidden = wl.length === 0; }
  };
  document.addEventListener('click', (e) => {
    const btn = e.target.closest('[data-wishlist-btn]');
    if (!btn) return;
    e.preventDefault();
    const id = btn.dataset.wishlistBtn;
    const wl = getWishlist();
    const idx = wl.indexOf(id);
    if (idx >= 0) { wl.splice(idx, 1); toast('Removed from wishlist'); }
    else { wl.push(id); toast('Saved to wishlist'); }
    setWishlist(wl); syncWishlistUI();
  });
  syncWishlistUI();

  // ---------- Cart Drawer + AJAX ----------
  const cartDrawer = $('.cart-drawer');
  const openCart = () => cartDrawer && cartDrawer.classList.add('open');
  const closeCart = () => cartDrawer && cartDrawer.classList.remove('open');
  $$('[data-cart-open]').forEach((b) => b.addEventListener('click', (e) => { e.preventDefault(); openCart(); refreshCart(); }));
  $$('[data-cart-close]').forEach((b) => b.addEventListener('click', closeCart));
  if (cartDrawer) $('.overlay', cartDrawer)?.addEventListener('click', closeCart);

  const fetchCart = async () => {
    const r = await fetch('/cart.js', { headers: { Accept: 'application/json' } });
    return r.json();
  };
  const renderCart = (cart) => {
    const count = cart.item_count || 0;
    $$('[data-cart-count]').forEach((el) => { el.textContent = count; el.hidden = count === 0; });
    const linesEl = $('[data-cart-lines]');
    const subEl = $('[data-cart-subtotal]');
    const emptyEl = $('[data-cart-empty]');
    const footEl = $('[data-cart-foot]');
    if (!linesEl) return;
    if (!cart.items || cart.items.length === 0) {
      linesEl.innerHTML = '';
      if (emptyEl) emptyEl.hidden = false;
      if (footEl) footEl.hidden = true;
      return;
    }
    if (emptyEl) emptyEl.hidden = true;
    if (footEl) footEl.hidden = false;
    linesEl.innerHTML = cart.items.map((it) => `
      <div class="cart-line" data-line-key="${it.key}">
        <a class="thumb" href="${it.url}"><img src="${it.image ? it.image.replace(/(\.[a-z]+)(\?.*)?$/i, '_200x$1$2') : ''}" alt=""></a>
        <div style="flex:1;min-width:0">
          <h4>${it.product_title}</h4>
          <div class="b">${it.vendor || ''}</div>
          <div class="row">
            <div class="qty-ctl">
              <button data-qty-dec="${it.key}" aria-label="Decrease">−</button>
              <span class="v">${it.quantity}</span>
              <button data-qty-inc="${it.key}" aria-label="Increase">+</button>
            </div>
            <div class="price">${money(it.final_line_price)}</div>
          </div>
          <button data-remove-line="${it.key}" style="margin-top:8px;color:rgba(255,255,255,.4);font-size:12px">Remove</button>
        </div>
      </div>`).join('');
    if (subEl) subEl.textContent = money(cart.items_subtotal_price);
  };
  const refreshCart = async () => renderCart(await fetchCart());

  const changeLine = async (key, qty) => {
    const r = await fetch('/cart/change.js', {
      method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ id: key, quantity: qty }),
    });
    return r.json();
  };
  document.addEventListener('click', async (e) => {
    const inc = e.target.closest('[data-qty-inc]');
    const dec = e.target.closest('[data-qty-dec]');
    const rem = e.target.closest('[data-remove-line]');
    if (inc) { const line = e.target.closest('.cart-line'); const q = parseInt($('.v', line).textContent, 10); renderCart(await changeLine(inc.dataset.qtyInc, q + 1)); }
    if (dec) { const line = e.target.closest('.cart-line'); const q = parseInt($('.v', line).textContent, 10); renderCart(await changeLine(dec.dataset.qtyDec, Math.max(0, q - 1))); }
    if (rem) { renderCart(await changeLine(rem.dataset.removeLine, 0)); }
  });

  // Add to cart AJAX
  document.addEventListener('click', async (e) => {
    const btn = e.target.closest('[data-add-to-cart]');
    if (!btn) return;
    e.preventDefault();
    if (btn.disabled) return;
    const id = btn.dataset.addToCart;
    const qtyInput = btn.closest('form')?.querySelector('[name="quantity"]');
    const quantity = qtyInput ? parseInt(qtyInput.value, 10) || 1 : 1;
    btn.disabled = true;
    try {
      const r = await fetch('/cart/add.js', {
        method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({ items: [{ id, quantity }] }),
      });
      if (!r.ok) throw new Error('Cart add failed');
      await refreshCart();
      openCart();
      toast('Added to cart');
    } catch (err) { toast('Could not add — sold out?'); }
    finally { btn.disabled = false; }
  });

  // Product form (main product page): submit intercepts
  $$('form[action^="/cart/add"]').forEach((form) => {
    form.addEventListener('submit', async (e) => {
      e.preventDefault();
      const btn = form.querySelector('[type=submit]');
      if (btn) btn.disabled = true;
      try {
        const fd = new FormData(form);
        const r = await fetch('/cart/add.js', { method: 'POST', body: fd, headers: { Accept: 'application/json' } });
        if (!r.ok) throw new Error();
        await refreshCart(); openCart(); toast('Added to cart');
      } catch { toast('Could not add — sold out?'); }
      finally { if (btn) btn.disabled = false; }
    });
  });

  // Initial cart sync
  fetchCart().then(renderCart).catch(() => {});

  // Buy Now
  $$('[data-buy-now]').forEach((b) => b.addEventListener('click', async (e) => {
    e.preventDefault();
    const form = b.closest('form');
    if (!form) return;
    const fd = new FormData(form);
    await fetch('/cart/add.js', { method: 'POST', body: fd, headers: { Accept: 'application/json' } });
    window.location.href = '/checkout';
  }));

  // ---------- Product qty controls ----------
  $$('[data-qty-input]').forEach((input) => {
    const wrap = input.closest('.qty-ctl');
    if (!wrap) return;
    $('button[data-inc]', wrap)?.addEventListener('click', () => { input.value = parseInt(input.value || 1, 10) + 1; input.dispatchEvent(new Event('change')); });
    $('button[data-dec]', wrap)?.addEventListener('click', () => { input.value = Math.max(1, parseInt(input.value || 1, 10) - 1); input.dispatchEvent(new Event('change')); });
  });

  // ---------- Product gallery ----------
  $$('[data-gallery]').forEach((gal) => {
    const main = $('[data-gallery-main]', gal);
    $$('[data-gallery-thumb]', gal).forEach((thumb) => {
      thumb.addEventListener('click', () => {
        const src = thumb.dataset.src;
        if (main && src) $('img', main).src = src;
        $$('[data-gallery-thumb]', gal).forEach((t) => t.classList.remove('active'));
        thumb.classList.add('active');
      });
    });
    if (main) main.addEventListener('click', () => main.classList.toggle('zoom'));
  });

  // ---------- Search modal (predictive) ----------
  const searchModal = $('.search-modal');
  const openSearch = () => { if (searchModal) { searchModal.classList.add('open'); $('input[data-search-input]', searchModal)?.focus(); } };
  const closeSearch = () => searchModal && searchModal.classList.remove('open');
  $$('[data-search-open]').forEach((b) => b.addEventListener('click', (e) => { e.preventDefault(); openSearch(); }));
  $$('[data-search-close]').forEach((b) => b.addEventListener('click', closeSearch));

  const searchInput = searchModal ? $('input[data-search-input]', searchModal) : null;
  const searchResults = searchModal ? $('[data-search-results]', searchModal) : null;
  let searchTimer = null;
  if (searchInput) {
    searchInput.addEventListener('input', () => {
      clearTimeout(searchTimer);
      const q = searchInput.value.trim();
      if (!q) { if (searchResults) searchResults.innerHTML = ''; return; }
      searchTimer = setTimeout(async () => {
        try {
          const r = await fetch(`/search/suggest.json?q=${encodeURIComponent(q)}&resources[type]=product&resources[limit]=8&resources[options][unavailable_products]=last`, { headers: { Accept: 'application/json' } });
          const data = await r.json();
          const items = data.resources?.results?.products || [];
          if (searchResults) {
            if (items.length === 0) { searchResults.innerHTML = `<div style="grid-column:1/-1;text-align:center;color:rgba(255,255,255,.5);padding:32px">No results for "${q}"</div>`; return; }
            searchResults.innerHTML = items.map((p) => `
              <a href="${p.url}" class="search-result">
                <img src="${p.image || (p.featured_image && p.featured_image.url) || ''}" alt="">
                <div style="flex:1;min-width:0">
                  <div class="font-manrope" style="font-weight:800;color:#fff;overflow:hidden;text-overflow:ellipsis;white-space:nowrap">${p.title}</div>
                  <div style="color:rgba(255,255,255,.5);font-size:11px;letter-spacing:.14em;text-transform:uppercase;margin-top:4px">${p.vendor || ''}</div>
                  <div style="color:var(--orange);font-family:Manrope,sans-serif;font-weight:900;margin-top:4px">${p.price ? money(p.price) : ''}</div>
                </div>
              </a>`).join('');
          }
        } catch {}
      }, 200);
    });
  }

  // Escape key closes overlays
  document.addEventListener('keydown', (e) => {
    if (e.key === 'Escape') { closeCart(); closeSearch(); mobileMenu?.classList.remove('open'); }
  });

  // ---------- Reveal on scroll ----------
  const observer = new IntersectionObserver((entries) => {
    entries.forEach((en) => { if (en.isIntersecting) { en.target.classList.add('animate-fadeUp'); observer.unobserve(en.target); } });
  }, { threshold: 0.08 });
  $$('[data-reveal]').forEach((el) => observer.observe(el));
})();
